module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-body__wrap"
  }, [_c('div', {
    staticClass: "cb-body__content"
  }, [_c('div', {
    staticClass: "cb-section"
  }, _vm._l((_vm.payment_method_list), function(payment_method, index) {
    return _c('div', {
      directives: [{
        name: "cb-link",
        rawName: "v-cb-link",
        value: ('shadow'),
        expression: "'shadow'"
      }],
      key: index,
      staticClass: "cb-options",
      class: {
        'cb-options--active': payment_method == _vm.selected_payment_method
      },
      on: {
        "click": function($event) {
          _vm.setPaymentMethod(payment_method)
        }
      }
    }, [_c('div', {
      staticClass: "cb-options__group"
    }, [_c('div', {
      staticClass: "cb-options__left"
    }, [_c('div', {
      staticClass: "cb-options__radio",
      style: (payment_method == _vm.selected_payment_method && _vm.backgroundColor)
    }, [_c('i', {
      staticClass: "icon-check cb-options__icon",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "cb-options__right"
    }, [_c('payment-method-summary', {
      attrs: {
        "persistent-payment-method": payment_method,
        "transient-payment-method": payment_method.transient && payment_method
      }
    })], 1)])])
  })), _vm._v(" "), _c('div', {
    staticClass: "cb-section"
  }, [(_vm.canAdd) ? _c('cb-button', {
    attrs: {
      "custom-class": 'secondary',
      "attr": 'add_payment_action'
    },
    on: {
      "next": function($event) {
        _vm.navigate('payment_method')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.t('payment_method.choose.add')) + "\n      ")]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fc7f73c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/ChoosePaymentMethod.vue
// module id = 585
// module chunks = 66